exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".voerro-notifications-container[data-v-46ff0126]{position:fixed;width:25%;z-index:100}.top-left[data-v-46ff0126]{top:.5rem;left:1rem}.bottom-left[data-v-46ff0126]{bottom:.91rem;left:1rem}.top-right[data-v-46ff0126]{top:.5rem;right:1rem}.bottom-right[data-v-46ff0126]{bottom:.5rem;right:1rem}.top-center[data-v-46ff0126]{width:50%;top:.5rem;left:25%}.bottom-center[data-v-46ff0126]{width:50%;bottom:.5rem;left:25%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46ff0126","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Notifications.vue
// module id = 13
// module chunks = 0